import CommunicationToolsPage from "../../components/communication-tools";

const ussdPageProps = {
  heroTitle: "Interactive Communication Without the Internet",
  heroDescription:
    "SleengShort’s USSD solutions empower businesses to create interactive, real-time communication channels that work on any mobile device—no internet required. Whether you’re collecting data, processing payments, or providing customer support, USSD is the perfect tool for seamless engagement.",
  heroImage:
    "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744333068/ussd-hero_cv2ls3.png",

  whyChooseTitle: "Why Choose SleengShort USSD service",
  features: [
    {
      icon: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744333068/instant-connectivity_tjaxx8.png",
      title: "Instant Connectivity",
      descr: "No app downloads or internet needed.",
    },
    {
      icon: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744333068/customizable-menus_kkii6p.png",
      title: "Customizable Menus",
      descr: "Design interactive menus tailored to your business.",
    },
    {
      icon: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744333068/secure-transactions_br3byt.png",
      title: "Secure Transactions",
      descr: "Ideal for mobile banking, payments, and data collection.",
    },
    {
      icon: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744333067/wide-reach_y3jiwy.png",
      title: "Wide Reach",
      descr: "Accessible on all mobile devices, even basic phones.",
    },
  ],

  useCaseTitle: "Use Case",
  useCases: [
    {
      img: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744333067/use-case-mobile-banking_loec14.png",
      title: "Mobile Banking",
      descr:
        "Allow customers to check balances, transfer funds, and pay bills instantly—no internet or app required.",
    },
    {
      img: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744333073/use-case-customer-feedback_y5c3h0.png",
      title: "Customer Feedback",
      descr:
        "Collect valuable insights through interactive surveys and polls, even in low-connectivity areas.",
    },
    {
      img: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744333067/use-case-service-activation_evpgaa.png",
      title: "Service Activation",
      descr:
        "Enable users to activate subscriptions, top-up airtime, or purchase data bundles with a few clicks.",
    },
  ],
};

const USSDPage = () => {
  return <CommunicationToolsPage {...ussdPageProps} />;
};

export default USSDPage;
